import { useEffect, useState } from 'react';
import { LinearProgress } from '@mui/material';
import { withStyles } from '@mui/styles';
import styles from './ccf-digital-email-template.module.scss';

const StyledLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: '#D5DEE6;',
  },
  barColorPrimary: {
    backgroundColor: '#8B99A8',
  },
})(LinearProgress);

/* eslint-disable-next-line */
export interface CcfEmailProgressBarProps {
  progressCallback: any;
  attachmentId: number;
}

/**
 * Used to display the Email Progress bar
 * @example - CcfEmailProgressBar
 */
export function CcfEmailProgressBar(props: CcfEmailProgressBarProps) {
  const [progress, setProgress] = useState(0);
  const { progressCallback, attachmentId } = props;

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          // return 0;
          clearInterval(timer);
        }
        const diff = Math.random() * 25;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);
    setProgress((state) => {
      return state;
    });
    progressCallback(progress, attachmentId);
    return () => {
      clearInterval(timer);
    };
  }, [progress]);

  return (
    <div style={{ display: progress === 100 ? 'none' : 'flex', width: '100%' }}>
      <StyledLinearProgress
        className={styles.linearProgressBar}
        variant="determinate"
        value={progress}
      />
    </div>
  );
}

export default CcfEmailProgressBar;
